<template>
  <b-col offset="1">
    <column-picker :column="leftColumn" :required="isRequired" @change="updateSubColumn"
                   :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                   defaultOptionText="Please choose an option" :isGrouping="false" :isSubGrouping="false"
                   :isAggregate="isAggregate" :hasLabel="false" :allowedDataTypes="allowedDataTypes"
                   prepend="Add:">
    </column-picker>
    <column-picker :column="rightColumn" :required="isRequired" @change="updateSubColumn"
                   :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                   defaultOptionText="Please choose an option" :isGrouping="false" :isSubGrouping="false"
                   :isAggregate="isAggregate" :hasLabel="false" :allowedDataTypes="allowedDataTypes"
                   prepend="to:">
    </column-picker>
  </b-col>
</template>

<script>

export default {
  name: 'add-column-options',
  props: ['column', 'columnSpec', 'isRequired', 'columnSpecCategories', 'reportType', 'report', 'isAggregate', 'isRequired'],
  components: { 'column-picker': () => import('@/components/reports/ColumnPicker') },
  data () {
    return {
      leftColumn: this.column.sub_columns[0] || { column_id: null, label: null, sub_columns: [], options: {} },
      rightColumn: this.column.sub_columns[1] || { column_id: null, label: null, sub_columns: [], options: {} }
    }
  },
  computed: {
    allowedDataTypes () {
      return this.columnSpec.component_column_data_types
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    updateSubColumn () {
      this.column.sub_columns[0] = this.leftColumn
      this.column.sub_columns[1] = this.rightColumn
      this.emitChange()
    },
    emitChange () {
      this.$emit('change', this.column)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/AddColumnOptions.vue